const initialState = [];

function deviceTypesReducer(state = initialState, action) {
  switch (action.type) {
    case "deviceTypes/update":
      return action.payload;
    case "deviceTypes/delete":
      return state.filter(
        (deviceType) => !action.payload.includes(deviceType.id)
      );
    default:
      return state;
  }
}
export default deviceTypesReducer;
